<template>
  <div>
    <!-- Hero -->
    <base-page-heading :title="$t('admin.comparisonGroups.title')">
      <template #extra>
        <b-breadcrumb class="breadcrumb-alt">
          <b-breadcrumb-item>
            <router-link to="/">{{ $t("layout.breadcrumb.home") }}</router-link>
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            {{ $t("layout.breadcrumb.admin") }}
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            {{ $t("admin.comparisonGroups.title") }}
          </b-breadcrumb-item>
        </b-breadcrumb>
      </template>
    </base-page-heading>
    <!-- END Hero -->

    <!-- Remove Main Group Block Modal -->
    <b-modal
      id="modal-block-remove-main-group"
      body-class="p-0"
      hide-footer
      hide-header
    >
      <div class="block block-themed block-transparent mb-0">
        <div class="block-header bg-primary-dark">
          <h3 class="block-title">
            {{ $t("admin.comparisonGroups.modal.remove.title") }}
          </h3>
          <div class="block-options">
            <button
              type="button"
              class="btn-block-option"
              @click="$bvModal.hide('modal-block-remove-main-group')"
            >
              <i class="fa fa-fw fa-times"></i>
            </button>
          </div>
        </div>
        <div class="block-content font-size-sm">
          <p>
            {{
              $t("admin.comparisonGroups.modal.remove.text", {
                mainGroup: removeMainGroupData.name
              })
            }}
          </p>
        </div>
        <div class="block-content block-content-full text-right border-top">
          <b-button
            variant="light"
            size="sm"
            @click="$bvModal.hide('modal-block-remove-main-group')"
          >
            {{ $t("admin.comparisonGroups.modal.remove.no") }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="removeMainGroup(removeMainGroupData.mainGroupId)"
          >
            <i class="fa fa-check mr-1"></i>
            {{ $t("admin.comparisonGroups.modal.remove.yes") }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- END Remove Main Group Block Modal -->

    <div class="content content-narrow">
      <b-row>
        <b-col xl="12">
          <base-block :title="$t('admin.comparisonGroups.search.title')">
            <input
              v-model="searchInput"
              :placeholder="$t('admin.comparisonGroups.search.placeholder')"
              class="form-control"
            />
            <br />
          </base-block>
        </b-col>
      </b-row>
    </div>

    <div class="content content-narrow">
      <b-row
        v-for="(mainGroup, index) in comparisonMainGroups"
        v-bind:key="index"
      >
        <b-col
          xl="12"
          v-if="
            search == '' || mainGroup.name.toLowerCase().indexOf(search) !== -1
          "
        >
          <base-block :title="mainGroup.name" class="comparison-main-group">
            <template #options v-if="Auth.isUserManager()">
              <b-button
                size="sm"
                @click="
                  editComparisonMainGroup =
                    editComparisonMainGroup === index ? null : index
                "
              >
                <i class="fa fa-fw fa-pencil-alt"></i>
              </b-button>
              <b-button
                @click="removeMainGroupData = mainGroup"
                v-b-modal.modal-block-remove-main-group
                size="sm"
                class="margin-left"
                variant="alt-danger"
              >
                <i class="fa fa-fw fa-times"></i>
              </b-button>
            </template>
            <div v-if="editComparisonMainGroup === index">
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="comparisonMainGroups[index].name"
                  @keyup.enter="saveMainGroup"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    @click="saveMainGroup"
                  >
                    <i class="fa fa-fw fa-save"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <br />
            </div>
            <b-table-simple
              responsive
              bordered
              striped
              table-class="table-vcenter"
              :id="'table' + index"
            >
              <b-thead>
                <b-tr>
                  <b-th class="text-center col-10">
                    {{ $t("admin.comparisonGroups.table.name") }}
                  </b-th>
                  <b-th class="col-2">
                    {{ $t("admin.comparisonGroups.table.action") }}
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tfoot v-if="Auth.isUserManager()">
                <b-tr>
                  <b-th>
                    <input
                      type="text"
                      v-model="addForm[mainGroup.mainGroupId]"
                      class="form-control"
                      :placeholder="
                        $t('admin.comparisonGroups.table.newGroupPlaceholder')
                      "
                      @keyup.enter="addGroup(mainGroup.mainGroupId)"
                    />
                  </b-th>
                  <b-th>
                    <b-button
                      size="sm"
                      variant="alt-primary"
                      @click="addGroup(mainGroup.mainGroupId)"
                    >
                      <i class="fa fa-fw fa-plus"></i>
                    </b-button>
                  </b-th>
                </b-tr>
              </b-tfoot>
              <b-tbody>
                <b-tr
                  v-for="(comparisonGroup, groupIndex) in mainGroup.subGroups"
                  v-bind:key="groupIndex"
                >
                  <b-td class="text-left">
                    {{ comparisonGroup.shortName }}
                  </b-td>
                  <b-td>
                    <router-link
                      :to="
                        '/admin/comparison_groups/' +
                          comparisonGroup.comparisonGroupId +
                          '/'
                      "
                    >
                      <b-button size="sm" variant="alt-primary">
                        <i class="fa fa-fw fa-pencil-alt"></i>
                      </b-button>
                    </router-link>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </base-block>
        </b-col>
      </b-row>
      <b-row v-if="Auth.isUserManager()">
        <b-col xl="12">
          <base-block
            :title="$t('admin.comparisonGroups.newMainGroup.title')"
            class="comparison-main-group"
          >
            <b-table-simple
              responsive
              bordered
              striped
              table-class="table-vcenter"
            >
              <b-tbody>
                <b-tr>
                  <b-th class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="newComparisonMainGroup"
                      :placeholder="
                        $t('admin.comparisonGroups.newMainGroup.placeholder')
                      "
                    />
                  </b-th>
                  <b-th class="col-2">
                    <b-button
                      size="sm"
                      variant="alt-primary"
                      @click="addMainGroup"
                    >
                      <i class="fa fa-fw fa-plus"></i>
                    </b-button>
                  </b-th>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </base-block>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import ComparisonMainGroups from "@/assets/js/ComparisonMainGroups";
import ComparisonGroups from "@/assets/js/ComparisonGroups";
import Loading from "@/store/loading";
import Notification from "@/assets/js/Notification";
import Auth from "@/assets/js/Auth";

export default {
  name: "comparisonGroups",
  components: {},
  data() {
    return {
      addForm: [],
      searchInput: "",
      editComparisonMainGroup: null,
      newComparisonMainGroup: "",
      comparisonMainGroups: [],
      removeMainGroupData: {
        name: "",
        mainGroupId: 0
      },
      Auth: Auth
    };
  },
  mounted() {
    this.getMainGroups();
    document.title = this.$t("admin.comparisonGroups.title");

    Notification.init(this);
  },
  methods: {
    getMainGroups: function() {
      Loading.dispatch("increase", 1);
      ComparisonMainGroups.getListWithSubGroups().then(comparisonMainGroups => {
        this.$set(this, "comparisonMainGroups", comparisonMainGroups);
        Loading.dispatch("reduce");
      });
    },
    addGroup: function(mainGroupId) {
      if (
        typeof this.addForm[mainGroupId] === "string" &&
        this.addForm[mainGroupId] != ""
      ) {
        Loading.dispatch("increase", 1);
        ComparisonGroups.add(
          mainGroupId,
          this.addForm[mainGroupId],
          this.addForm[mainGroupId],
          ""
        ).then(result => {
          Loading.dispatch("reduce");
          if (result) {
            this.$router.push("/admin/comparison_groups/" + result + "/");
          }
        });
      } else {
        Notification.push(
          "",
          this.$t("admin.comparisonGroups.notifications.notAdded"),
          "danger"
        );
      }
    },
    addMainGroup: function() {
      if (
        typeof this.newComparisonMainGroup === "string" &&
        this.newComparisonMainGroup !== ""
      ) {
        Loading.dispatch("increase");

        ComparisonMainGroups.add(this.newComparisonMainGroup).then(() => {
          Loading.dispatch("reduce");
          this.newComparisonMainGroup = "";
          this.getMainGroups();
          Notification.push(
            "",
            this.$t("admin.comparisonGroups.notifications.mainGroupAdded"),
            "success"
          );
        });
      } else {
        Notification.push(
          "",
          this.$t("admin.comparisonGroups.notifications.mainGroupNotAdded"),
          "danger"
        );
      }
    },
    removeMainGroup: function(mainGroupId) {
      this.$bvModal.hide("modal-block-remove-main-group");
      Loading.dispatch("increase");
      ComparisonMainGroups.remove(mainGroupId).then(result => {
        if (result) {
          this.getMainGroups();
          Notification.push(
            "",
            this.$t("admin.comparisonGroups.notifications.mainGroupDeleted"),
            "success"
          );
        } else {
          Notification.push(
            "",
            this.$t("admin.comparisonGroups.notifications.mainGroupNotDeleted"),
            "danger"
          );
        }
        Loading.dispatch("reduce");
      });
    },
    saveMainGroup: function() {
      Loading.dispatch("increase");
      if (this.newComparisonMainGroup !== null) {
        let mainGroup = this.comparisonMainGroups[this.editComparisonMainGroup];
        ComparisonMainGroups.update(mainGroup.mainGroupId, mainGroup.name).then(
          result => {
            if (result) {
              this.editComparisonMainGroup = null;
              Notification.push(
                "",
                this.$t(
                  "admin.comparisonGroups.notifications.mainGroupChanged"
                ),
                "success"
              );
            } else {
              Notification.push(
                "",
                this.$t(
                  "admin.comparisonGroups.notifications.mainGroupNotChanged"
                ),
                "danger"
              );
            }
            Loading.dispatch("reduce");
          }
        );
      }
    }
  },
  computed: {
    search: function() {
      return this.searchInput.toLowerCase();
    }
  }
};
</script>

<style lang="scss" scoped="scoped">
.margin-left {
  margin-left: 1em;
}
</style>
